module.exports = __webpack_public_path__ + "static/vojta-857eadd523482ec3be3eaf41678f5851.jpg";